import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { calculateEffectiveLength } from '../../../lib/dbqTextLimitUtils';

const DbqRemarksEditorModal = ({
  show,
  onHide,
  value,
  onChange,
  onSave,
  isSaving = false,
  submitMode = null,
  remarksFieldInfo = null,
  readOnly = false,
  title = 'Edit Full Medical Opinion',
}) => {
  const fullLength = String(value || '').length;
  const remarksMaxLength = remarksFieldInfo?.maxLength || null;
  const remarksCharsPerLine = remarksFieldInfo?.charsPerLine || null;
  const remarksUsage = remarksCharsPerLine
    ? calculateEffectiveLength(value || '', remarksCharsPerLine)
    : fullLength;
  const isBusy = Boolean(isSaving);
  const isSavingChanges = isBusy && submitMode === 'save';

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Full Medical Opinion</Form.Label>
          <Form.Control
            as="textarea"
            rows={14}
            value={value || ''}
            onChange={(event) => onChange?.(event.target.value)}
            disabled={isSaving}
            readOnly={readOnly}
            placeholder="Enter the full Medical Opinion text."
          />
          <Form.Text className="text-muted">
            {fullLength.toLocaleString()} characters in the full text
            {remarksMaxLength && (
              <>
                {' '}|{' '}
                {remarksUsage.toLocaleString()} / {remarksMaxLength.toLocaleString()}
                {' '}
                {remarksCharsPerLine ? 'effective characters' : 'remarks characters'}
              </>
            )}
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isBusy}>
          {readOnly ? 'Close' : 'Cancel'}
        </Button>
        {!readOnly ? (
          <Button
            variant="outline-primary"
            onClick={onSave}
            disabled={isBusy || !String(value || '').trim()}
          >
            {isSavingChanges ? (
              <>
                <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </Button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

export default DbqRemarksEditorModal;
